const getCompanyEmailPattern = require("./getCompanyEmailPattern");

/**
 * @param companyEmailInput {HTMLInputElement}
 * @return {void}
 */
module.exports = function setCompanyEmailInputPattern(companyEmailInput) {
    const companyEmailPattern = getCompanyEmailPattern();

    if (companyEmailPattern) {
        companyEmailInput.setAttribute("pattern", companyEmailPattern);
    }
}